import $ from 'jquery'
import { KEY_CODE_MAP } from '@utils/keyboard-helpers'

window.TabGroups = {}

const getUrlHash = (el, tabs, panels, binding) => {
  const disableDeepLink = ['communications']
  const urlHash = window.location.href.split('#')[1] || null
  let tabActive = null
  let tabIndex = 0
  tabs.forEach((element, index) => {
    element.setAttribute('data-index', index)
    if(!disableDeepLink.includes(element.getAttribute('data-id'))) {
      el.querySelector('.tab-group-panels').children[index].setAttribute('id', element.getAttribute('data-id'))
    }
  })

  panels.forEach((element, index) => {
    element.setAttribute('data-index', index)
  })

  if (urlHash != null) {
    try {
      tabActive = el.querySelector(`[data-id="${urlHash}"]`)
      tabIndex = tabActive.getAttribute('data-index')
    } catch (err) {
      tabActive = el.querySelector('.tab-group-tab.active')
      tabIndex = 0
    }

    showHideTabGroup(el, tabIndex, tabActive, tabs, panels, binding)
  } else {
    setTimeout(() => {
      tabActive = el.querySelector('.tab-group-tab.active')
      tabIndex = tabActive.getAttribute('data-index')

      showHideTabGroup(el, tabIndex, tabActive, tabs, panels, binding)
    }, 100)
  }
}

const animateSlider = (el, tab, binding) => {
  if (tab == null) {
    tab = el.querySelector('.tab-group-tab.active')
  }
  if (!binding.value.tabOrientationVertical) {
    const firstEl = parseInt($(tab).attr('data-index'), 10)
    const elem = $(tab).find('.title')
    const defaultDynLeft = binding.value?.leftOffset ?? 45
    const firstDynLeft = binding.value?.leftOffset ?? 45
    let dynLeft
    if (firstEl === 0) {
      if (window.document.dir === 'rtl') {
        dynLeft = defaultDynLeft
      } else {
        dynLeft = firstDynLeft
      }
    } else {
      dynLeft = defaultDynLeft
    }
    setTimeout(() => {
      const tabSlider = el.querySelector('.tab-group-slider')
      const { left } = $(el).find(tab).position()
      const width = elem.width()
      tabSlider.style.left = `${left + dynLeft}px`
      tabSlider.style.width = `${width}px`
    }, 100)
  }
}

const showHideTabGroup = (el, currentIndex, tab, tabs, panels, binding, userClickEvent) => {
  if (tab == null) {
    tab = el.querySelector('.tab-group-tab.active')
  }
  panels.forEach((panel) => {
    panel.classList.remove('active')
    panel.setAttribute('aria-hidden', true)
  })
  tabs.forEach((currentTab) => {
    currentTab.classList.remove('active')
    currentTab.querySelector('.tab-group-button').setAttribute('tabindex', -1)
    currentTab.querySelector('.tab-group-button').setAttribute('aria-selected', false)
  })
  tab.classList.add('active')
  tab.querySelector('.tab-group-button').setAttribute('tabindex', 0)
  tab.querySelector('.tab-group-button').setAttribute('aria-selected', true)
  try {
    panels[currentIndex].classList.add('active')
    panels[currentIndex].setAttribute('aria-hidden', false)
    if (userClickEvent) {
      window.history.pushState(null, null, `#${tab.getAttribute('data-id')}`)
    }
  } catch (err) {
    console.log('error', err)
  }
  animateSlider(el, tab, binding)
}

const getElements = (el) => {
  const tabs = el.querySelectorAll('.tab-group-tab')
  const panels = el.querySelectorAll('.tab-group-panel')
  return { tabs, panels }
}

const expEditorChangeTab = (binding, currentIndex) => {
  const el = document.getElementById(binding.value.componentId)
  const { tabs, panels } = getElements(el)
  showHideTabGroup(el, currentIndex, tabs[currentIndex], tabs, panels, binding)
}

export const tabGroup = {
  name: 'tabgroup',
  inserted: (el, binding, vnode) => {
    const { tabs, panels } = getElements(el)
    const isExpEditor = vnode.context.$store.state.global.isXPE
    if (!isExpEditor) {
      getUrlHash(el, tabs, panels, binding)
    } else {
      window.TabGroups[binding.value.componentId] = expEditorChangeTab.bind(this, binding)
      window.TabGroups[binding.value.componentId](0)
    }

    if (!isExpEditor) {
      const tabsArr = Array.from(tabs) // Convert NodeList to array
      const firstTab = tabsArr[0]
      const lastTab = tabsArr[tabsArr.length - 1]

      const handleTabInteraction = (index, tab) => {
        const focusTab = (focusableElementIndex) => {
          const nextTab = tabsArr[focusableElementIndex]
          if (nextTab) {
            const anchorElement = nextTab.querySelector('a')
            if (anchorElement) {
              showHideTabGroup(el, focusableElementIndex, nextTab, tabsArr, panels, binding)
              anchorElement.focus()
            }
          }
        }

        return (e) => {
          if (e.keyCode === KEY_CODE_MAP.TAB) return
          e.preventDefault()

          if (e.type === 'click' || e.code === 'Enter' || e.code === 'Space') {
            showHideTabGroup(el, index, tab, tabsArr, panels, binding, true)
          } else if (e.keyCode === KEY_CODE_MAP.ARROW_UP || e.keyCode === KEY_CODE_MAP.ARROW_LEFT) {
            if (tab === firstTab) {
              const focusableElementIndex = tabsArr.indexOf(lastTab)
              focusTab(focusableElementIndex)
            } else {
              const focusableElementIndex = tabsArr.indexOf(tab) - 1
              focusTab(focusableElementIndex)
            }
          } else if (e.keyCode === KEY_CODE_MAP.ARROW_DOWN || e.keyCode === KEY_CODE_MAP.ARROW_RIGHT) {
            if (tab === lastTab) {
              const focusableElementIndex = tabsArr.indexOf(firstTab)
              focusTab(focusableElementIndex)
            } else {
              const focusableElementIndex = tabsArr.indexOf(tab) + 1
              focusTab(focusableElementIndex)
            }
          }
        }
      }

      tabsArr.forEach((tab, index) => {
        const eventHandler = handleTabInteraction(index, tab)
        $(tab).on('keydown click', eventHandler)
      })

      const isSticky = el.classList.contains('sticky-tabs')

      if (isSticky) {
        const stickyEl = el.querySelector('.tab-group-tabs.container')
        const container = stickyEl.parentElement

        window.addEventListener('scroll', () => {
          const stickyRect = stickyEl.getBoundingClientRect()
          const containerRect = container.getBoundingClientRect()

          const isPinned = stickyRect.top > containerRect.top

          stickyEl.classList.toggle('is-pinned', isPinned)
        })
      }
    }
  }
}
